import { render, staticRenderFns } from "./CoBookingModal.vue?vue&type=template&id=3578a4dc&scoped=true&"
import script from "./CoBookingModal.vue?vue&type=script&lang=ts&"
export * from "./CoBookingModal.vue?vue&type=script&lang=ts&"
import style0 from "./CoBookingModal.vue?vue&type=style&index=0&id=3578a4dc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3578a4dc",
  null
  
)

export default component.exports